import { $ } from '@zimpa/dom';
import { Modal } from '../modal/modal';
import axios from "axios";
import Handlebars from 'handlebars/dist/cjs/handlebars'

const TRIGGER_CLASS = 'js-document-link';
const MODAL_SELECTOR = '.js-modal';
const DOCUMENT_LINK_SUBMIT_SELECTOR = '.js-document-link__submit';
const LIAME_FIELD_SELECTOR = '.js-document__liame';
const EMAIL_FIELD_SELECTOR = '.js-document__email';
const PRIVACY_FIELD_SELECTOR = '.js-document__privacy';
const FORM_SELECTOR = '.js-documents-form';

const FEEDBACK_SUCCESS_SELECTOR = '.js-shared-files__feedback--success';
const FEEDBACK_ERROR_SELECTOR = '.js-shared-files__feedback--error';
const FEEDBACK_INVALID_SELECTOR = '.js-shared-files__feedback--invalid';

const CLASS_HIDE = 'h-hide';



export function handle(el: HTMLElement): void {
    const data = JSON.parse(<string>el.getAttribute('data-modal'));
    const tpl = $(<string>el.getAttribute('data-modal-template-selector'));

    if (tpl === undefined) {
        return;
    }

    const template = Handlebars.compile(tpl.innerHTML);
    const content = template(data);

    Modal.open(content);
    el.dispatchEvent(new CustomEvent('ModalOpen'));

    const modal = $(MODAL_SELECTOR);

    const submit = $(DOCUMENT_LINK_SUBMIT_SELECTOR,modal);

    submit?.addEventListener('click',(e) => {
        e.preventDefault();

        const privacy = $<HTMLInputElement>(PRIVACY_FIELD_SELECTOR,modal);
        const email = $<HTMLInputElement>(LIAME_FIELD_SELECTOR,modal);
        const form = $<HTMLInputElement>(FORM_SELECTOR,modal);

        if(!privacy?.checked||email?.value==='') {
            $<HTMLElement>(FEEDBACK_INVALID_SELECTOR,modal)?.classList.remove(CLASS_HIDE);
        } else {
            $<HTMLElement>(FEEDBACK_INVALID_SELECTOR,modal)?.classList.add(CLASS_HIDE);
            form?.classList.add(CLASS_HIDE);

            axios
                .post(`/wp-json/zmp_personal_shared_files/v1/handle_registration`,{
                    email: $<HTMLInputElement>(EMAIL_FIELD_SELECTOR,modal)?.value,
                    id: data.id,
                    liame: $<HTMLInputElement>(LIAME_FIELD_SELECTOR,modal)?.value,
                })
                .then((response) => {
                    if(response.data.success) {
                        $<HTMLElement>(FEEDBACK_SUCCESS_SELECTOR,modal)?.classList.remove(CLASS_HIDE);
                    } else {
                        $<HTMLElement>(FEEDBACK_ERROR_SELECTOR,modal)?.classList.remove(CLASS_HIDE);
                    }
                });
        }



    })

}

export function documentLink(): void {
    document.body.addEventListener('click', (event: MouseEvent): void => {
        if (
            event.target &&
            (<HTMLElement>event.target).classList.contains(TRIGGER_CLASS)
        ) {
            handle(<HTMLElement>event.target);
        }
    });
}
